import React, { useCallback } from 'react';
import { ErrorMessage, useField } from 'formik';
import trim from 'lodash/trim';
import { ButtonRectangleRadioGroup } from '@yme/atoms/button-select';
import { ButtonSquareGroup } from '@yme/atoms/button-select/ButtonSquareGroup';
import { Dropdown } from '@yme/atoms/dropdown';
import { Input, INPUT_STATE_ERROR } from '@yme/atoms/input';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel5 } from '@yme/tokens/typography';
import { FormFieldDate } from './FormFieldDate';
import { FormFieldType } from './types';
export const FormField = ({ name, fieldType, wrapperGap = '12px', wrapperFlexDirection, isValidateOnBlur = false, onChange, renderMessageCallback, isRadioVisible, ...other }) => {
    const [field, meta, helpers] = useField(name);
    const setValue = useCallback((value) => {
        helpers.setValue(value);
    }, [helpers]);
    const setTouched = useCallback(() => {
        helpers.setTouched(true);
    }, [helpers]);
    const renderErrorMessage = useCallback((message) => trim(message) && (React.createElement(RegularTextLevel5, { color: colorBrandYamahaRed }, renderMessageCallback ? renderMessageCallback(message) : message)), [renderMessageCallback]);
    const handleFieldOnChange = useCallback((value) => {
        if (!isValidateOnBlur) {
            setTouched();
        }
        setValue(value);
        onChange?.(value);
    }, [onChange, setTouched, setValue, isValidateOnBlur]);
    const renderField = () => {
        switch (fieldType) {
            case FormFieldType.INPUT:
                return (React.createElement(Input, { name: name, value: field.value, state: meta.error && meta.touched ? INPUT_STATE_ERROR : undefined, changeHandler: handleFieldOnChange, blurHandler: setTouched, ...other }));
            case FormFieldType.TEXTAREA:
                return (React.createElement(Input, { isTextarea: true, name: name, value: field.value, state: meta.error && meta.touched ? INPUT_STATE_ERROR : undefined, changeHandler: setValue, blurHandler: setTouched, ...other }));
            case FormFieldType.DATEPICKER:
                return (React.createElement(FormFieldDate, { date: field.value, inputState: meta.error && meta.touched ? INPUT_STATE_ERROR : undefined, id: String(other.id), onDateChange: handleFieldOnChange, onInputBlur: handleFieldOnChange, isRightToLeft: Boolean(other.isRightToLeft), isRequired: Boolean(other.isRequired), ...other }));
            case FormFieldType.DROPDOWN:
                return (React.createElement(Dropdown, { activeItem: field.value, id: String(other.id), onChange: setValue, blurHandler: setTouched, ...other }));
            case FormFieldType.BUTTON_RADIO:
                return (React.createElement(FlexWrapper, { gap: wrapperGap, flexDirection: wrapperFlexDirection },
                    React.createElement(ButtonRectangleRadioGroup, { isRadioVisible: isRadioVisible, selectedValue: field.value, setActiveOption: setValue, contentTag: other.contentTag, allOptions: other.allOptions, possibleOptions: other.possibleOptions, ...other })));
            case FormFieldType.BUTTON_SQUARE:
                return (React.createElement(FlexWrapper, { gap: wrapperGap, flexDirection: wrapperFlexDirection },
                    React.createElement(ButtonSquareGroup, { ...other, selectedValue: field.value, contentTag: other.contentTag, allOptions: other.allOptions, possibleOptions: other.possibleOptionsButtonSquare })));
            default:
                return null;
        }
    };
    return (React.createElement(FlexWrapper, { isFullWidth: true, flexDirection: "column", gap: "10px" },
        renderField(),
        React.createElement(ErrorMessage, { name: name, render: renderErrorMessage })));
};
